<aside class="flex flex-col h-full p-5">
  <div class="relative flex items-center justify-center md:justify-between md:p-3">
    <button class="absolute left-0 p-3 cursor-pointer md:hidden" (click)="toggleMenu()">
      <i class="pi text-white" [class.pi-bars]="!isMenuOpen" [class.pi-times]="isMenuOpen"></i>
    </button>

    <img width="100" height="100" ngSrc="assets/images/jcb-impact-logo.svg" alt="JCB Impact Logo" />

    <div class="absolute right-0 flex space-x-3 md:hidden">
      <button class="flex items-center justify-center h-9 w-9 border border-white rounded-full cursor-pointer" (click)="toggleSearch()">
        <i class="pi pi-search text-white w-4 h-4"></i>
      </button>
      <button class="relative flex items-center justify-center h-9 w-9 border border-white rounded-full cursor-pointer" (click)="notificationsService.toggleNotifications()">
        @if (hasUnreadNotifications$ | async) {
          <div class="absolute top-0 right-0 -translate-x-1.25 translate-y-1.2 flex items-center justify-center bg-red-icon rounded-full min-w-3 h-3"></div>
        }
        <i class="pi pi-bell text-white w-4 h-4"></i>
      </button>
    </div>
  </div>

  <nav
    [ngClass]="{
      'fixed flex left-0 right-0 bottom-0 top-[82px] bg-black p-4 z-10': isMenuOpen,
      'relative hidden grow-1 md:mt-10 md:flex md:flex-col': !isMenuOpen,
    }"
  >
    <ul class="flex flex-col grow-1 gap-1">
      <li>
        <a
          class="flex items-center text-grey-400 px-4 py-4 rounded-sm transition hover:bg-grey-900"
          routerLink="/"
          routerLinkActive="bg-grey-900 text-white font-bold"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="pi pi-th-large text-xl mr-3"></i> {{ 'navigation.dashboard' | transloco }}
        </a>
      </li>
      <li>
        <a class="flex items-center text-grey-400 px-4 py-4 rounded-sm transition hover:bg-grey-900" routerLink="/settings" routerLinkActive="bg-grey-900 text-white font-bold">
          <i class="pi pi-cog text-xl mr-3"></i> {{ 'navigation.settings' | transloco }}
        </a>
      </li>
      <li>
        <a class="flex items-center text-grey-400 px-4 py-4 rounded-sm transition hover:bg-grey-900" href="mailto:hub@jcb.com?subject=Feedback for JCB Hub Web" (click)="handleFeedbackClick()">
          <i class="pi pi-comments text-xl mr-3"></i> {{ 'navigation.feedback' | transloco }}
        </a>
      </li>
      <li class="mt-auto relative before:w-[calc(100%+--spacing(10))] before:h-1 before:absolute before:-top-5 before:-left-5 before:border-b before:border-grey-600">
        <a
          class="flex items-center text-white px-4 py-4 rounded-sm transition hover:bg-grey-900"
          [href]="jcbPortal"
        >
          <i class="pi pi-sign-out text-xl mr-3"></i> {{ 'navigation.exit' | transloco }}
        </a>
      </li>
    </ul>
  </nav>

  <div
    [ngClass]="{
      'fixed flex flex-col left-0 right-0 bottom-0 top-[82px] bg-white p-4 z-10': isSearchOpen,
      'relative hidden grow-1 md:mt-10': !isSearchOpen,
    }"
  >
    <div class="relative w-full border-b border-grey-200 pb-4 mb-8">
      <input (ngModelChange)="searchTerm$.next($event)" [ngModel]="searchTerm$.value" class="py-2.5 px-6 w-full text-grey-600 text-sm" name="search" type="text" [placeholder]="'navigation.placeholder' | transloco"/>

      @if (searchTerm$ | async) {
        <button class="absolute right-[4px] top-[3.5px] flex items-center justify-center h-9 w-9 cursor-pointer" (click)="searchTerm$.next('')">
          <i class="pi pi-times w-4 h-4" style="font-size: 14px"></i>
        </button>
      }
    </div>

    <div class="overflow-auto">
      <app-search-results />
    </div>
  </div>
</aside>

<app-notifications />
